import { makeRequestAction } from './index';

export const sendFollowUpEmail = makeRequestAction(
  'SEND_FOLLOW_UP_EMAIL',
  {
    onSuccess(params, response) {
      return {
        response: {
          ...response,
        },
      };
    },
  },
);
